export class Onboarding {
  static readonly COMPANY = 0;
  static readonly COMPLETED = 1;
}
